import { ArrowLeftIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../../apps/frontend/src/context/ThemeStore';
import FeatureCardSecond from './generic/FeatureCardSecond';
import { AppLayout } from '../Layout/AppLayout';
import axios from 'axios';
import { usePackStorage } from '../Layout/usePackStorage';

export default function ExploreQuizrr() {
  const navigate = useNavigate();
  const { isDarkTheme } = useContext(ThemeContext);
  const [availableExams, setAvailableExams] = useState([]);

  const { purchasedPacks, selectedPack } = usePackStorage();

  const imgBasePath = isDarkTheme ? '/svg-explore-quizrr-dark' : '/svg-explore-quizrr';

  useEffect(() => {
    const fetchExams = async () => {
      try {
        const response = await axios.get('/api/user/profile/exams');
        console.log('Fetch response:', response);

        const exams = response?.data?.data?.exams || [];
        if (exams.length > 0) {
          const examTitles = exams.filter((exam) => exam.title !== 'All').map((exam) => exam.title);
          setAvailableExams(examTitles);
          console.log('Available exams:', examTitles);
        }
      } catch (error) {
        console.error('Error fetching exams:', error);
      }
    };

    fetchExams();
  }, []);

  const showJEEMain = availableExams.includes('JEE Main');
  const showJEEAdvanced = availableExams.includes('JEE Advanced');

  const videoCards = [
    {
      title: 'Attempt similar questions',
      description: 'Solve AI-picked similar questions to strengthen concepts and boost accuracy.',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/6jKlqTYaH00',
      isNew: true,
      tag: 'View Solution',
      iconSrc: `${imgBasePath}/svg12.svg`,
      condition: true,
    },
    {
      title: 'Get to Know Quizrr',
      description: 'A quick walkthrough of the Quizrr platform from attempting tests to checking analysis',
      duration: '3 MIN',
      videoUrl: 'https://www.youtube.com/embed/rR00gN7LmSM',
      tag: 'Quizrr Platform',
      iconSrc: `${imgBasePath}/svg1.svg`,
      condition: true,
    },
    {
      title: 'JEE Main Test Series – All Test Types Explained',
      description: 'Get clarity on how each test type helps in your JEE Main prep.',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/-HyfLb6nZP4',
      tag: 'Quizrr Platform',
      iconSrc: `${imgBasePath}/svg2.svg`,
      condition: showJEEMain,
    },
    {
      title: 'JEE Advanced Test Series – All Test Types Explained',
      description:
        'Learn about QAPTs, QAFs, PYQ, Chapter-wise Tests, and PYQ Chapter-wise Tests tailored for Advanced prep.',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/feDYF7Zv1Vo',
      tag: 'Quizrr Platform',
      iconSrc: `${imgBasePath}/svg4.svg`,
      condition: showJEEAdvanced,
    },
    {
      title: 'Make Best use of Test Analysis',
      description: 'Make sense of your performance with detailed insights.',
      duration: '6 MIN',
      videoUrl: 'https://www.youtube.com/embed/ic0voQcHtvA',
      tag: 'Test Analysis',
      iconSrc: `${imgBasePath}/svg11.svg`,
      condition: true,
    },
    {
      title: 'Pack Analysis Overview',
      description: 'Get a complete breakdown of your test packs—compare performance, accuracy, and consistency.',
      duration: '6 MIN',
      videoUrl: 'https://www.youtube.com/embed/jgT2q-GAQDY',
      tag: 'Pack Analysis',
      iconSrc: `${imgBasePath}/svg6.svg`,
      condition: true,
    },
    {
      title: 'Mistake Section',
      description: 'Revisit your mistakes, understand patterns, and focus on areas where you can improve the most.',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/AGevlDehxYE',
      tag: 'Mistakes',
      iconSrc: `${imgBasePath}/svg5.svg`,
      condition: true,
    },
    {
      title: 'Notebook – Save & Revisit Questions',
      description: 'Learn how to bookmark and organize important questions into notebooks.',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/UDxZp54ZhVU',
      tag: 'Notebook',
      iconSrc: `${imgBasePath}/svg7.svg`,
      condition: true,
    },
    {
      title: 'Resources Section – All Prep Tools in One Place',
      description: 'Explore session recordings, formula sheets, revision notes, and important PDFs.',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/r8wcZON-pME',
      tag: 'Resources',
      iconSrc: `${imgBasePath}/svg8.svg`,
      condition: true,
    },
    {
      title: 'Overview of Attempting Pattern - My Mistakes',
      description: 'Understand your common mistakes and learn strategies to avoid them in future tests.',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/4XWfUnxLXEs',
      tag: 'Mistakes',
      iconSrc: `${imgBasePath}/svg5.svg`,
      condition: true,
    },
    {
      title: 'Incorrect Question Tagging',
      description:
        'Tag and review incorrect questions to identify weak areas and turn mistakes into learning opportunities',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/pW72QZHu888',
      tag: 'View Solution',
      iconSrc: `${imgBasePath}/svg3.svg`,
      condition: true,
    },
    {
      title: 'Unattempted Questions Tagging',
      description:
        'Discover how to identify unattempted questions, enabling you to establish a pattern for future improvements.',
      duration: '2 MIN',
      videoUrl: 'https://www.youtube.com/embed/-RRxpCg906c',
      tag: 'View Solution',
      iconSrc: `${imgBasePath}/svg9.svg`,
      condition: true,
    },
  ];

  const filteredVideoCards = videoCards.filter((card) => card.condition);

  return (
    <AppLayout purchasedPacks={purchasedPacks} selectedPack={selectedPack}>
      <div className="bg-[var(--q3-surface-default)]">
        <main className="mx-auto w-full max-w-6xl px-4 py-6 md:py-10 ">
          {/* Header */}
          <header className="mb-6 flex items-center gap-3 relative">
            <button
              onClick={() => navigate(-1)}
              aria-label="Go back"
              className="rounded-full p-2 bg-[var(--q3-surface-dimmer)] cursor-pointer absolute left-0 top-0"
            >
              <ArrowLeftIcon className="h-5 w-5 text-[var(--q3-neutral-default)]" />
            </button>

            <div className="w-full flex justify-center md:justify-start">
              <h1 className="sr-only">Explore & Learn Quizrr</h1>
            </div>
          </header>

          {/* Top Section */}
          <section className="mb-10 flex flex-col items-center gap-6 md:grid md:grid-cols-[1.2fr_0.8fr] md:items-center">
            <div className="order-1 md:order-2 mx-auto w-[146px] h-[146px] md:w-[260px] md:h-[244px] aspect-square md:aspect-auto">
              <img
                src={`${imgBasePath}/svg10.svg`}
                alt="Learning illustration"
                className="w-full h-full object-contain"
              />
            </div>

            <div className="order-2 md:order-1 text-center md:text-left">
              <h2 className="text-balance font-semibold text-[42px] md:text-[56px] leading-[52px] md:leading-[64px] tracking-[-1.176px] text-[var(--q3-neutral-default)]">
                Explore Quizrr
              </h2>

              <p className="mt-3 w-full max-w-[434px] text-[16px] md:text-[18px] leading-[22px] md:leading-[24px] text-[var(--q3-neutral-light)] mx-auto md:mx-0">
                Your go-to section to learn, master, and make the most of Quizrr. Watch step-by-step guides, tips, and
                tutorials to boost your preparation and stay on track.
              </p>
            </div>
          </section>

          {/* Featured Videos */}
          <section aria-labelledby="featured" className="mb-4">
            <h3 className="text-2xl font-bold text-[var(--q3-neutral-default)] text-center md:text-left">
              Featured Videos
            </h3>

            <div
              className="
      mt-6
      grid grid-cols-1 gap-4
      sm:grid-cols-2
      md:[@media(min-width:1024px)]:grid-cols-3
      [@media(min-width:1139px)]:lg:grid-cols-4
    "
            >
              {filteredVideoCards.map((card, index) => (
                <FeatureCardSecond
                  key={index}
                  title={card.title}
                  description={card.description}
                  duration={card.duration}
                  videoUrl={card.videoUrl}
                  isNew={card.isNew}
                  tag={card.tag}
                  iconSrc={card.iconSrc}
                />
              ))}
            </div>
          </section>
        </main>
      </div>
    </AppLayout>
  );
}
